
/**
 * 浏览器端登录
 * @param {String} backUrl 登录后返回的链接
 * @return {Promise} 登录信息
 */
export default function login (backUrl) {
  const protocol = window.location.protocol
  // const loginApi = `${protocol}//localhst:9127/login`
  const loginApi = `http://localhst:9127/login`
  const requestURL = encodeURIComponent(`${loginApi}?backUrl=${backUrl.replace(/&/g, '@')}`)
  // const loginURL = `${protocol}//account.wps.cn/login?hide=wx&cb=${requestURL}`
  const loginURL = `http://account.wps.cn/login?hide=wx&cb=${requestURL}`

  setTimeout(() => (window.location.href = loginURL))
  return Promise.resolve({ msg: '跳转登录页面' })
}
